import React from 'react';
import { Link } from 'react-router';
import { detectMobile } from '../../utils/UiHelper';

const EventsHighlightsCompany = ({ companyImg, companyUrl }) => {
    return (
        <Link
            to={`/kampagner/${companyUrl}`}
            style={{
                backgroundImage: `url(${
                    window.config.baseCmsPath
                }${companyImg})`,
            }}
            className={`${
                detectMobile() ? 'mobile' : ''
            } events-highlights-company`}
        />
    );
};

export default EventsHighlightsCompany;
